/**
 * Product Comparison Functionality - UPGRADED WITH RICH DATA
 * Manages adding/removing products for comparison including specs_json
 */

class ProductCompare {
  constructor() {
    this.storageKey = 'compareProducts';
    this.maxProducts = 4;
    this.products = this.getProducts();
    this.init();
  }

  init() {
    this.createFloatingBar();
    this.attachEventListeners();
    this.updateUI();
  }

  // Get products from localStorage
  getProducts() {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : [];
  }

  // Save products to localStorage
  saveProducts() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.products));
  }

  // Add product to comparison
  addProduct(productData) {
    // 1. ПРОВЕРКА ЗА КАТЕГОРИЯ
    if (this.products.length > 0) {
      const currentCategory = this.products[0].type; 
      const newCategory = productData.type; 

      if (currentCategory !== newCategory) {
        const confirmSwitch = confirm(
          `В момента сравнявате продукти от категория "${currentCategory}". \n\n` +
          `Желаете ли да ИЗЧИСТИТЕ текущия списък, за да добавите "${productData.title}" (${newCategory})?`
        );

        if (confirmSwitch) {
          this.products = []; 
        } else {
          return false; 
        }
      }
    }

    // 2. Стандартна проверка за дублиране
    if (this.products.some(p => p.id === productData.id)) {
      this.showNotification('Продуктът вече е добавен за сравнение');
      return false;
    }

    // 3. Лимит на продуктите
    if (this.products.length >= this.maxProducts) {
      this.showNotification(`Можете да сравните максимум ${this.maxProducts} продукта`);
      return false;
    }

    // Всичко е наред - добавяме
    this.products.push(productData);
    this.saveProducts();
    this.updateUI();
    this.showNotification('Продуктът е добавен за сравнение');
    return true;
  }

  // Remove product from comparison
  removeProduct(productId) {
    this.products = this.products.filter(p => p.id !== productId);
    this.saveProducts();
    this.updateUI();
    this.showNotification('Продуктът е премахнат от сравнението');
  }

  // Clear all products
  clearAll() {
    if (confirm('Сигурни ли сте, че искате да изчистите всички продукти за сравнение?')) {
      this.products = [];
      this.saveProducts();
      this.updateUI();
      this.showNotification('Всички продукти са премахнати');
    }
  }

  // Check if product is in comparison
  isInCompare(productId) {
    return this.products.some(p => p.id === productId);
  }

  // Create floating bar HTML
  createFloatingBar() {
    if (document.querySelector('.compare-floating-bar')) return;

    const bar = document.createElement('div');
    bar.className = 'compare-floating-bar';
    bar.innerHTML = `
      <span>Продукти за сравнение: <span class="compare-count">0</span></span>
      <button class="compare-view-btn" onclick="window.location.href='/pages/compare'">
        Виж сравнението
      </button>
      <button class="compare-clear-btn">Изчисти</button>
    `;
    document.body.appendChild(bar);

    // Clear button event
    bar.querySelector('.compare-clear-btn').addEventListener('click', () => {
      this.clearAll();
    });
  }

  // Update UI elements
  updateUI() {
    const bar = document.querySelector('.compare-floating-bar');
    const count = document.querySelector('.compare-count');
    
    if (bar && count) {
      count.textContent = this.products.length;
      if (this.products.length > 0) {
        bar.classList.add('show');
      } else {
        bar.classList.remove('show');
      }
    }

    document.querySelectorAll('.product-compare-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      if (this.isInCompare(productId)) {
        btn.classList.add('added');
        const textElem = btn.querySelector('.compare-btn-text');
        if (textElem) textElem.textContent = 'Добавен';
      } else {
        btn.classList.remove('added');
        const textElem = btn.querySelector('.compare-btn-text');
        if (textElem) textElem.textContent = 'Сравни';
      }
    });
  }

  attachEventListeners() {
    document.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest('.product-compare-btn');
      if (!btn) return;

      e.preventDefault();
      const productId = btn.dataset.productId;

      if (this.isInCompare(productId)) {
        this.removeProduct(productId);
      } else {
        // НАДГРАДЕН ОБЕКТ: Събираме и JSON спецификациите
        const productData = {
          id: productId,
          handle: btn.dataset.productHandle,
          title: btn.dataset.productTitle,
          price: btn.dataset.productPrice,
          comparePrice: btn.dataset.productComparePrice,
          image: btn.dataset.productImage,
          url: btn.dataset.productUrl,
          available: btn.dataset.productAvailable === 'true',
          vendor: btn.dataset.productVendor,
          type: btn.dataset.productType,
          // ХИРУРГИЧЕСКА ДОБАВКА: Взимаме JSON-а от скрит дата атрибут
          specs: btn.dataset.productSpecs || "" 
        };
        this.addProduct(productData);
      }
    });
  }

  // Show notification
  showNotification(message) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4338CA;
      color: white;
      padding: 16px 24px;
      border-radius: 50px;
      z-index: 10000;
      animation: slideIn 0.3s ease;
      box-shadow: 0 4px 12px rgba(67, 56, 202, 0.3);
    `;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Get products for comparison page
  getCompareProducts() {
    return this.products;
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  window.productCompare = new ProductCompare();
});

// Animations
if (!document.getElementById('compare-animations')) {
  const style = document.createElement('style');
  style.id = 'compare-animations';
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(400px); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(400px); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}